export const IconsByLevelSport: Record<number, string> = {
  1: 'chart_low',
  7: 'chart_normal',
  2: 'chart_hi',
}

export const MaskPhone = '+7(###)###-##-##'
